export const VpCategories = {
  bgm: '背景音乐',
  animation: {
    single: '单个动画',
    all: '全部动画',
  },
  movieClip: '序列帧',
  dragonBone: '龙骨',
  particle: '粒子特效',
  basic: {
    switchAndAction: '跳转及埋点',
    node: '素材',
    timer: '计时器',
    event: '事件',
    bgm: '背景音乐',
  },
  audio: '音效',
  video: '视频',
  drawLine: '连线组件',
  freeDrawLine: '画线组件',
  erase: '擦除组件',
  carousel: '轮播组件',
  mask: '遮罩组件',
  other: '其他',
}
